import SchemaError from './SchemaError';
const transformMethods = ['getDeviceInfo', 'getSupportedEvents'];
const nativeCodeSuccess = 0;
export function transformRes(method, res) {
    const { result, value, message } = res || {};
    let businessValue = value;
    /**
     * 'getDeviceInfo', 'getSupportedEvents' 两个个方法在 6.64 以下版本返回值没有区分业务 result 和框架层 result。
     * 所以，对于这四个方法， 如果返回的值只有一层 result。 则把整个返回值提供给业务方使用
     */
    if (transformMethods.includes(method) && result === nativeCodeSuccess) {
        const isNewValue = Object.prototype.toString.call(businessValue) === '[object Object]' && Object.prototype.hasOwnProperty.call(businessValue, 'result');
        if (!isNewValue) {
            businessValue = res;
        }
    }
    if (result === nativeCodeSuccess) {
        return businessValue;
    }
    throw new SchemaError(result, message);
}
